// Function to initialize brand carousel
export function initializeBrandSection(container?: HTMLElement | null) {
    const carouselElement = container 
        ? container.querySelector('.brand-one__carousel')
        : document.querySelector('.brand-one__carousel');
    
    if (!carouselElement) {
        return;
    }

    // Check if Swiper is available
    const Swiper = (window as any).Swiper;
    if (typeof Swiper === 'undefined') {
        setTimeout(() => initializeBrandSection(container), 500);
        return;
    }

    // Check if already initialized
    if ((carouselElement as any).swiper) {
        return; // Already initialized
    }

    try {
        new Swiper(carouselElement as HTMLElement, {
            slidesPerView: 5,
            spaceBetween: 0,
            speed: 600,
            loop: true,
            pagination: {
                el: '#swiper-dot-style1',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '#swiper-button-prev1',
                prevEl: '#swiper-button-next1'
            },
            autoplay: {
                delay: 8000
            },
            breakpoints: {
                0: {
                    spaceBetween: 10,
                    slidesPerView: 3
                },
                375: {
                    spaceBetween: 10,
                    slidesPerView: 3
                },
                575: {
                    spaceBetween: 15,
                    slidesPerView: 3
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 3
                },
                992: {
                    spaceBetween: 30,
                    slidesPerView: 4
                },
                1200: {
                    spaceBetween: 30,
                    slidesPerView: 5
                },
                1320: {
                    spaceBetween: 30,
                    slidesPerView: 5
                }
            }
        });

    } catch (error) {
    }
}

// Expose function globally for use in other scripts
if (typeof window !== 'undefined') {
    (window as any).initializeBrandSection = initializeBrandSection;
}

